import firebase, {auth, db} from '../../../utils/firebase';
import {storageRef} from '../../Fire';

export const addPlanetToDb = newPlanet =>
    db
        .collection(`planets`)
        .add({
            ...newPlanet,

            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            createdBy: {
                uid: auth().currentUser.uid,
                displayName: auth().currentUser.displayName,
            },
        })
        .then(() => ({error: false, message: 'Планета успешно добавлена'}))
        .catch(() => ({error: true, message: 'Произошла ошибка при добавлении планеты'}))

export const updatePlanetAtDb = (id, updatedPlanetData, fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, planets: true});

    return db
        .doc(`planets/${id}`)
        .update({
            ...updatedPlanetData,
            editedAt: firebase.firestore.FieldValue.serverTimestamp(),
            editedBy: {
                uid: auth().currentUser.uid,
                displayName: auth().currentUser.displayName,
            },
        })
        .then(() => ({error: false, message: 'Планета успешно обновлена'}))
        .catch(() => ({error: true, message: 'Произошла ошибка при обновлении планеты'}))
        .finally(() => setFetchingState({...fetchingState, planets: false}))
}

export const checkForPlanetsUpdatesAtDb = (fetchingState, setFetchingState, setPlanets, errors, setErrors) => {
    setFetchingState({...fetchingState, planets: true});

    return db
        .collection('planets')
        .onSnapshot(
            (snapshot) => {
                const newPlanets = [];
                snapshot.forEach((doc) => {
                    newPlanets.push({id: doc.id, data: doc.data()});
                })

                setFetchingState({...fetchingState, planets: false});
                setPlanets(newPlanets);
            },
            () => {
                setErrors({...errors, planets: 'Ошибка доступа к базе'});
                setFetchingState({...fetchingState, planets: false});
            }
        )
}

/**
 * Структуру берем, аналогичную структуре из serializers.js, находящегося в functions, но дублируем, а не
 * осуществляем импорт, чтобы не перемешивать functions и public.
 * Цвет ауры по умолчанию берем из trackInfo (#e1bee7), а не (#ffffff), который указан на данный момент в структуре
 * трека из serializers.
 */

const getTrackStruct = (track) => ({
    ref: track.ref.path,
    auraColor: track.data.auraColor || '#e1bee7',
    name: track.data.name || '',
    description: track.data.description || '',
    nightDescription: track.data.nightDescription || '',
    trackUrl: track.data.trackUrl || '',
    trackTimespan: track.data.trackTimespan || 0,
    nightTrackUrl: track.data.nightTrackUrl || '',
    nighttrackTimespan: track.data.nightTrackTimespan || '',
    trackStatus: track.data.trackStatus || 'regular'
});

export const getLastAddedTrackFromDb = (planetId, localeId) => {
    return db
        .collection(`planets/${planetId}/tracks_${localeId}`)
        .orderBy('createdAt', 'desc')
        .limit(1)
        .get()
        .then(snapshot => {
            const newTracks = [];
            snapshot.forEach(doc => {
                const data = doc.data();
                newTracks.push({id: doc.id, data, ref: doc.ref});
            });
            return newTracks[0];
        })
}

export const updateHistoryAtDb = async (planetId, track, eventType, changedData) => {
    let objectType, eventBy, struct;

    if (eventType === 'onUpdate' || eventType === 'onCreate' || eventType === 'onDelete') {
        objectType = track.ref.parent.id;
        eventBy = {
            uid: auth().currentUser.uid,
            displayName: auth().currentUser.displayName
        }
        struct = getTrackStruct(track);
    }

    if (eventType === 'onUpdate' && changedData) {
        struct.changes = changedData;
    }

    if (struct === undefined) {
        return;
    }

    const historyObj = {
        object: struct,
        editDate: firebase.firestore.FieldValue.serverTimestamp(),
        eventType,
        objectType,
        eventBy
    }

    return db
        .collection(`planets/${planetId}/history`)
        .add(historyObj);
}

export const getHistoryFromDb = (planetId, fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, history: true});

    return db
        .collection(`planets/${planetId}/history`)
        .orderBy('editDate', 'desc')
        .get()
        .then((snapshot) => {
            const history = [];
            snapshot.forEach((doc) => {
                history.push({id: doc.id, data: doc.data()});
            })

            return history;
        })
        .finally(() => setFetchingState({...fetchingState, history: false}))
}

export const addTrackToDb = (planetId, localeId, newTrack) => {
    const trackCreator = {
        ref: `users/${auth().currentUser.uid}`,
        name: auth().currentUser.displayName,
    }
    return db
        .collection(`planets/${planetId}/tracks_${localeId}`)
        .add({
            ...newTrack,
            trackCreator,

            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            createdBy: {
                uid: auth().currentUser.uid,
                displayName: auth().currentUser.displayName,
            },
        })
        .then(() => ({error: false, message: 'Трек успешно добавлен'}))
        .catch(() => ({error: true, message: 'Произошла ошибка при добавлении трека'}))
}

export const updateTrackAtDb = async (planetId, trackId, localeId, updatedTrackData, trackFileUrl, trackTimespan,
                                      nightTrackFileUrl, nightTrackTimespan, fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, tracks: true});

    const lastEditAuthor = {
        ref: `users/${auth().currentUser.uid}`,
        name: auth().currentUser.displayName,
    };
    const lastEditDate = firebase.firestore.Timestamp.fromDate(new Date());

    if (trackFileUrl) {
        updatedTrackData.trackUrl = trackFileUrl;
    }

    if (nightTrackFileUrl) {
        updatedTrackData.nightTrackUrl = nightTrackFileUrl;
    }

    return db
        .doc(
            `planets/${planetId}/tracks_${localeId}/${trackId}`
        )
        .update({
            ...updatedTrackData,
            lastEditAuthor,
            lastEditDate,
            trackTimespan,
            nightTrackTimespan,

            editedAt: firebase.firestore.FieldValue.serverTimestamp(),
            editedBy: {
                uid: auth().currentUser.uid,
                displayName: auth().currentUser.displayName,
            },
        })
        .then((doc) => ({error: false, message: 'Трек успешно обновлен'}))
        .finally(() => setFetchingState({...fetchingState, tracks: false}))
        .catch(() => setFetchingState({...fetchingState, tracks: false}))
}

export const checkForTracksUpdatesAtDb = (planetId, localeId, fetchingState, setFetchingState, tracks, setTracks, errors, setErrors) => {
    setFetchingState({...fetchingState, tracks: true});

    return db
        .collection(`planets/${planetId}/tracks_${localeId}`)
        .orderBy('createdAt', 'asc')
        .onSnapshot(
            async (snapshot) => {
                const newTracks = [];
                snapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.lastEditDate !== undefined) {
                        data.lastEditDate = data.lastEditDate.toDate();
                    }
                    if (data.lastPushDateTime !== undefined) {
                        data.lastPushDateTime = data.lastPushDateTime.toDate();
                    }
                    newTracks.push({id: doc.id, data, ref: doc.ref});
                })
                setTracks({...tracks, [planetId + localeId]: newTracks});
                setFetchingState({...fetchingState, tracks: false});
            },
            () => {
                setErrors({...errors, tracks: 'Ошибка доступа к базе'});
                setFetchingState({...fetchingState, tracks: false});
            }
        )
}

export const deleteTrackAtDb = (planetId, localeId, trackId, fetchingState, setFetchingState) => {
    setFetchingState({...fetchingState, tracks: true});

    return db
        .doc(
            `planets/${planetId}/tracks_${localeId}/${trackId}`
        )
        .delete()
        .then(async (doc) => {
            storageRef.child(`sounds/${trackId}`).delete();

            return {error: false, message: 'Трек успешно удален'};
        })
        .catch(() => ({error: true, message: 'Произошла ошибка при удалении трека'}))
        .finally(() => setFetchingState({...fetchingState, tracks: false}))
}

export const tracksMigrationAtDb = async () => {
    const planets = await db.collection('planets').get()
        .then(snapshot => {
            const planets = [];
            snapshot.forEach(doc => {
                planets.push({id: doc.id, data: doc.data()});
            });
            return planets;
        });

    for (const planet of planets) {
        const playlists = await db.collection(`planets/${planet.id}/playlists`).get()
            .then(snapshot => {
                const playlists = [];
                snapshot.forEach(doc => {
                    playlists.push({id: doc.id, data: doc.data()});
                });
                return playlists;
            });

        for (const playlist of playlists) {
            const tracks = await db.collection(`planets/${planet.id}/playlists/${playlist.id}/tracks`).get()
                .then(snapshot => {
                    const tracks = [];
                    snapshot.forEach(doc => {
                        tracks.push({id: doc.id, data: doc.data(), ref: doc.ref});
                    });
                    return tracks;
                });

            for (const track of tracks) {
                await db.collection(`planets/${planet.id}/tracks_ru`).add({...track.data});
            }
        }
    }

    console.log('tracks migration finished');
}
